import moment from 'moment';

export const dateformatConverter = (dateTime, format) => {
  if (!!dateTime) {
    return moment(dateTime).format(`${format}`);
  } else return "";
};

export const humanReadableDate = ({ dateTime }) => {
  if (!!dateTime) {
    return moment(`${dateTime}`, 'YYYYMMDD').fromNow()
  } else return "";
};
export const humanReadableDateOnlyInDays = ({ dateTime }) => {
  if (!!dateTime) {

    const now = moment()

    return now.diff(dateTime, 'days')
  } else return "";
};



